import TexsController from './texs.controller';
import Template from './texs.html';

export default {
    controller: TexsController,
    template: Template
};
